export default __webpack_public_path__ + "static/2177-28e8ba62d19bf61d251d714bbee5c2c7.gif";